import { jsxs as t, jsx as o } from "react/jsx-runtime";
const r = ({ className: C }) => /* @__PURE__ */ t(
  "svg",
  {
    width: "41",
    height: "41",
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: C,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M12.332 30.8889V26.7222M12.332 26.7222V24.2222C12.332 23.4365 12.332 23.0437 12.5883 22.7996C12.8446 22.5555 13.2571 22.5555 14.082 22.5555H15.2487C16.4568 22.5555 17.4362 23.4883 17.4362 24.6389C17.4362 25.7895 16.4568 26.7222 15.2487 26.7222H12.332ZM35.6654 22.5555H33.4779C32.1029 22.5555 31.4155 22.5555 30.9883 22.9623C30.5612 23.3691 30.5612 24.0239 30.5612 25.3333V26.7222M30.5612 30.8889V26.7222M30.5612 26.7222H34.207M26.9154 26.7222C26.9154 29.0234 24.9566 30.8889 22.5404 30.8889C21.9952 30.8889 21.7226 30.8889 21.5195 30.7772C21.0334 30.5099 21.082 29.9688 21.082 29.5V23.9444C21.082 23.4756 21.0334 22.9345 21.5195 22.6672C21.7226 22.5555 21.9952 22.5555 22.5404 22.5555C24.9566 22.5555 26.9154 24.421 26.9154 26.7222Z",
          stroke: "#FA2C37",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M25.6628 37.5555H18.5416C13.1062 37.5555 10.3885 37.5555 8.50121 36.2258C7.96046 35.8448 7.48039 35.393 7.07559 34.8841C5.66276 33.1078 5.66276 30.5499 5.66276 25.4343V21.1919C5.66276 16.2533 5.66276 13.784 6.44432 11.8118C7.70079 8.64124 10.358 6.14035 13.7267 4.9578C15.8221 4.22221 18.4458 4.22221 23.6931 4.22221C26.6915 4.22221 28.1907 4.22221 29.3881 4.64254C31.3131 5.31829 32.8315 6.74737 33.5495 8.55911C33.9961 9.68607 33.9961 11.0971 33.9961 13.9192V17.5555",
          stroke: "#FA2C37",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M5.66536 20.8889C5.66536 17.8206 8.15267 15.3333 11.2209 15.3333C12.3306 15.3333 13.6388 15.5278 14.7176 15.2387C15.6762 14.9818 16.425 14.2331 16.6818 13.2745C16.9709 12.1956 16.7765 10.8874 16.7765 9.77777C16.7765 6.70953 19.2638 4.22222 22.332 4.22222",
          stroke: "#FA2C37",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  r as PdfFileIcon
};
